import {
  MAINNET_PERP_METADATA_BY_PRODUCT_ID,
  TESTNET_PERP_METADATA_BY_PRODUCT_ID,
} from '../commonPerpMetadataByProductId';

export const SEI_TESTNET_PERP_METADATA_BY_PRODUCT_ID =
  TESTNET_PERP_METADATA_BY_PRODUCT_ID;

export const SEI_PERP_METADATA_BY_PRODUCT_ID =
  MAINNET_PERP_METADATA_BY_PRODUCT_ID;
